import React from "react";
import amber from "../images/projects/amber.jpg";
import astra from "../images/projects/astra.jpg";
import auriga from "../images/projects/auriga.jpg";
import bion from "../images/projects/bion.png";
import capital from "../images/projects/capital.jpg";
import dra from "../images/projects/dra.jpg";
import folium from "../images/projects/folium.jpg";
import fortune from "../images/projects/fortune.jpg";
import jindal from "../images/projects/jindal.jpg";
import logisticpark from "../images/projects/logisticspark.jpg";
import mabelle from "../images/projects/mabelle.jpg";
import nucleus from "../images/projects/nucleus.jpg";
import parkeast from "../images/projects/parkeast.jpg";
import parkwest from "../images/projects/parkwest.jpg";
import sarang from "../images/projects/sarang.jpg";
import sushantam from "../images/projects/sushantam.jpg";
import windmere from "../images/projects/windmere.jpg";
import zion from "../images/projects/zion.jpg";

const Projects = () => {
    const projects = [
        {
            name: "Sumadhura Amber",
            description: "Mechanical Ventilation",
            image: amber,
        },
        {
            name: "BSCPL Astra",
            description: "Mechanical Ventilation, Electrical Panels",
            image: astra,
        },
        {
            name: "Concorde Auriga",
            description: "Mechanical Ventilation",
            image: auriga,
        },
        {
            name: "BSCPL Bion",
            description: "Mechanical Ventilation, Electrical Contracts",
            image: bion,
        },
        {
            name: "Sumadhura Capital Tower",
            description: "Building Management System",
            image: capital,
        },
        {
            name: "DRA Homes",
            description: "Mechanical Ventilation",
            image: dra,
        },
        {
            name: "Sumadhura Folium",
            description: "Mechanical Ventilation",
            image: folium,
        },
        {
            name: "Gopalan Fortune City",
            description: "Mechanical Ventilation",
            image: fortune,
        },
        {
            name: "Prestige Jindal City",
            description: "Mechanical Ventilation",
            image: jindal,
        },
        {
            name: "Sumashura Logistic Park",
            description: "Electrical Contracts",
            image: logisticpark,
        },
        {
            name: "Casagrand Mabelle",
            description: "Mechanical Ventilation",
            image: mabelle,
        },
        {
            name: "Ajmeera Nucleus",
            description: "Mechanical Ventilation",
            image: nucleus,
        },
        {
            name: "Ruchira Park East",
            description: "Electrical Contracts",
            image: parkeast,
        },
        {
            name: "Shapoorji Pallonji Park West",
            description: "Mechanical Ventilation",
            image: parkwest,
        },
        {
            name: "Sumadhura Sarang",
            description: "Electrical Contracts",
            image: sarang,
        },
        {
            name: "Sumadhura Sushantam",
            description: "Mechanical Ventilation",
            image: sushantam,
        },
        {
            name: "Purvankara Windmere",
            description: "Electrical Contracts",
            image: windmere,
        },
        {
            name: "BSCPL Zion",
            description: "Mechanical Ventilation, Electrical Contracts",
            image: zion,
        }
    ];

    const projectCards = projects.map((project, index) => (
        <div className="project-card" key={index}>
            <img src={project.image} alt={project.name} />
            <h2>{project.name}</h2>
            <p>{project.description}</p>
        </div>
    ));

    return (<div className='highlight'>
        <h1>Our Projects</h1>
        <div className="project-cards-wrapper">
            {projectCards}
            {/* <div className="project-card">
                <img src={amber} alt="amber" />
                <h2>Sumadhura Amber</h2>
                <p>Mechanical Ventilation</p>
            </div>
            <div className="project-card">
                <img src={astra} alt="astra" />
                <h2>BSCPL astra</h2>
                <p>Mechanical Ventilation, Electrical Panels</p>
            </div> */}
        </div>
    </div>
    );
};
export default Projects;